/* eslint-disable @typescript-eslint/no-explicit-any */
import { useState } from 'react';
import { useToast } from '@/hooks/use-toast';
import { UploadRequest } from '@/types';
import { serviceUpload } from '@/services/upload';

export const useFileUpload = () => {
  const [isUploading, setIsUploading] = useState(false);
  const { toast } = useToast();

  const handleUpload = async (data: UploadRequest) => {
    setIsUploading(true);

    try {
      const result = await serviceUpload(data);

      if (result.success) {
        toast({
          title: '✅ Arquivo enviado!',
          description: `${result.message}`,
        });
      }
    } catch (err: any) {
      toast({
        title: '❌ Erro',
        description: err.message,
        variant: 'destructive',
      });
    } finally {
      setIsUploading(false);
    }
  };

  return { handleUpload, isUploading, progress: 0 };
};
